import { render, staticRenderFns } from "./StImageVideo.vue?vue&type=template&id=0d399a89"
import script from "./StImageVideo.vue?vue&type=script&lang=ts"
export * from "./StImageVideo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports